export default __webpack_public_path__ + "static/ISO-invimatic-aad99f3136186904bc65a366d984344a.svg";